<template>
  <div name="assessmentReport" class="page">

 <section class="sm:auto-cols-min rounded w-full pb-6 pt-4" >
       
       <div class="p-2 pb-4 bg-white">
          <h4 class="titlebar">Overall Assessment</h4>
         <LineChart v-if="assessmentCount.length > 0" :data-source="assessmentCount" :labels="gradelabels" ></LineChart>
           <p v-else>We could not find any data for your given selection.</p>
       </div>
      </section>

<section class="sm:auto-cols-min rounded w-full pb-6 pt-4" >
              <div class="p-2 pb-4 bg-white">
          <h4 class="titlebar">&percnt; Working at levels</h4>
         <LineChart v-if="workingAt.length > 0" :data-source="workingAt" :labels="expectedLabels" :percentage="true"  ></LineChart>
           <p v-else>We could not find any data for your given selection.</p>
       </div>
     
      </section>


      <section class="sm:auto-cols-min rounded w-full pb-6 pt-4 mb-8" >
              <div class="p-2 pb-4 bg-white">
          <h4 class="titlebar">&percnt; Working at and above expected level</h4>
       
         <BarChart v-if="workingAt.length > 0 " :data-source="barWorkingAt" :percentage="true"  ></BarChart>
           <p v-else>We could not find any data for your given selection.</p>
       </div>
     
      </section>

  </div>
</template>

<script>

import { assessmentMixin } from "@/mixins/assessmentMixin.js";

const LineChart = () => import("@/components/charts/LineChart.vue");
const BarChart = () => import("@/components/charts/BarChart.vue");

export default {
  name: "assessmentReport",
  mixins : [ assessmentMixin ],
  props: ["data"],
  computed: {
    assessmentCount() {
      const vm = this
      const results = vm.data.map(function(res) {

        let totals = vm.grades.map(grade => {
        var filtered = res.scores.filter(assessment => {
          let filtered = true;

              filtered =
                assessment.grade >= grade.low &&
                assessment.grade < grade.high;
              return filtered;
            });

            return filtered.length

          });

         return {
            name: res.name,
            data: totals
          }


      })

      return results
    },
    workingAt() {
      const vm = this
      const results = vm.data.map(function(res) {

        let totals = vm.expectancies.map(expectancy => {
        var filtered = res.scores.filter(assessment => {
          let filtered = true;

              filtered =
                assessment.grade >= expectancy.low &&
                assessment.grade < expectancy.high;
              return filtered;
            });

            return Math.round(((filtered.length / res.scores.length) * 100))

          });

         return {
            name: res.name,
            data: totals
          }


      })

      return results
    },
    barWorkingAt() {
      const vm = this
      const results = vm.data.map(function(res) {

        const expectancy = vm.expectancies.find(e => e.key === 'expect_exceed')
        if (expectancy) {
          var filtered = res.scores.filter(assessment => {
          let filtered = true;

              filtered =
                assessment.grade >= expectancy.low &&
                assessment.grade < expectancy.high;
              return filtered;
            });


           return {
                    name: res.name,
                    value: Math.round(((filtered.length / res.scores.length) * 100))
                  }
        }

      })

      return results

    }
  },
  data() {
    return {

    };
  },
  created() {},
  mounted() {},
  methods: {},
  components: {
    LineChart,
    BarChart
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.titlebar { 
  @apply text-sm font-semibold mb-6 w-full text-center 
}
</style>
